import { Button, DatePicker, Select } from 'antd'
import styled from 'styled-components'

export const SelectEmployee = styled.div<{ marginLeft?: string; width?: string }>`
  display: flex;
  border: 1px solid;
  justify-content: space-between;
  width: ${({ width }) => (width ? width : '200px')};
  height: 35px;
  margin-left: ${({ marginLeft }) => (marginLeft ? marginLeft : '30px')};
`

export const NoteSelect = styled.div`
  width: 300px;
  height: 35px;
  white-space: pre-wrap;
  margin-left: 30px;
  font-size: 12px;
`

export const SelectCustom = styled(Select)`
  width: 200px;
  .ant-select-selector {
    border: none !important;
    outline: none !important;
  }
`
export const ButtonContainer = styled.div`
  display: flex;
  width: 100%;
  flex-wrap: wrap;
`
export const ButtonGroup = styled.div`
  margin-right: 20px;
`

export const SearchWrapper = styled.div`
  display: flex;
  border: 1px solid;
  margin-bottom: 10px;
  width: fit-content;
`

export const DatePickerCustom = styled(DatePicker)`
  width: 120px;
  display: block;
  border: none !important;
`
export const SelectWrapper = styled.div`
  display: flex;
  border: 1px solid;
  justify-content: space-between;
  height: 35px;
  margin-bottom: 10px;
  max-width: 300px;
`
export const NoteEmployee = styled.div`
  min-width: 300px;
  white-space: pre-wrap;
  font-size: 12px;
  margin-bottom: 13px;
  height: 35px;
`
export const ButtonExport = styled(Button)`
  width: 100px;
  margin-right: 20px;
  display: flex;
  justify-content: center;
`
export const ButtonGroupWrapper = styled.div`
  display: flex;
  align-items: center;
`
export const TitleSearchEmployee = styled.div<{ width?: string }>`
  width: ${({ width }) => (width ? width : 'auto')};
  padding: 0 5px;
  font-size: 16px;
  display: flex;
  align-items: center;
  border-right: 1px solid;
`

export const Wrappertable = styled.div`
  border-top: 1px solid;
  height: 600px;
  overflow: auto;
`
